import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { FC } from 'react'
import styled from 'styled-components'
import Text from './decorators/Text'

const StyledButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
  min-height: 70px;
  gap: 4px;
  padding: 12px 8px;
  color: var(--app-header-color-desktop-v3, var(--color-white));
`

const StyledButtonMobile = styled(StyledButton)`
  background-color: transparent;
  gap: 0;
  border-radius: 0;
  padding: 0;
  color: var(--app-header-color-mobile-v3, var(--color-white));
  min-height: auto;
`

interface FavoritesLayoutProps {
  className?: string
}

const FavoritesLayout: FC<FavoritesLayoutProps> = ({ className }) => {
  const {
    onClickFavorites,
    copies: { header: copy },
    isMobile,
  } = useHeaderContext()

  return isMobile ? (
    <StyledButtonMobile onClick={onClickFavorites} className={className}>
      <Icon className="ph-heart" size={24} />
    </StyledButtonMobile>
  ) : (
    <StyledButton onClick={onClickFavorites} className={className}>
      <Icon className="ph-heart" size={24} />
      <Text>{copy?.favorites}</Text>
    </StyledButton>
  )
}

export default FavoritesLayout
